export const getCityUf = (city: string, state: string) => {
  if (!city || !state) {
    return undefined;
  }

  const removeAccents = (str: string) =>
    str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

  const formattedCity = removeAccents(
    decodeURIComponent(city).trim().toLowerCase().replace(/\s+/g, "-")
  );
  return `${formattedCity}:${state.toLowerCase()}`;
};
